import { render, staticRenderFns } from "./Pocket.vue?vue&type=template&id=5b8bceb9"
import script from "./Pocket.vue?vue&type=script&lang=js"
export * from "./Pocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports